<script setup lang="ts">
import { useRouter } from 'vue-router'
import Button from 'primevue/button'
import AppCard from '@/components/ui/AppCard.vue'

const router = useRouter()
</script>

<template>
  <div class="min-h-screen flex items-center justify-center bg-surface-50 dark:bg-surface-950 px-4">
    <AppCard class="w-full max-w-md p-8 text-center animate-fade-in">
      <i class="pi pi-search text-6xl text-surface-300 dark:text-surface-600 mb-4" />
      <h1 class="text-3xl font-bold text-surface-900 dark:text-surface-100 mb-2">
        404
      </h1>
      <h2 class="text-xl text-surface-700 dark:text-surface-300 mb-4">
        Página no encontrada
      </h2>
      <p class="text-surface-500 dark:text-surface-400 mb-6">
        Lo sentimos, la página que buscas no existe o ha sido movida.
      </p>
      <div class="flex gap-3 justify-center">
        <Button
          label="Volver al inicio"
          icon="pi pi-home"
          @click="router.push({ name: 'home' })"
        />
        <Button
          label="Iniciar sesión"
          icon="pi pi-sign-in"
          severity="secondary"
          @click="router.push({ name: 'login' })"
        />
      </div>
    </AppCard>
  </div>
</template>